<template lang="pug">
  div
    div.label.basic600--text.text-uppercase.mb-2 {{ $t('source') }}
    v-text-field.mt-2(background-color="basic200" height="40" :placeholder= "$t('add_source')" outlined dense hide-details @click="openSourceOrderDialog = true" readonly)
      template(v-slot:append)
        eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
    v-row(no-gutters)
      v-col.shrink.pt-2.pr-2(v-for="(source, i) in sourceOrder" :key="i")
        v-chip.s2(small color="basic600" outlined close close-icon="mdi-close" @click:close="removeItem(source)" :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`") {{ source.name }}
    .modal
      add-source-order(v-if="openSourceOrderDialog" :open.sync="openSourceOrderDialog" :parentSelectedForms.sync="sourceOrder")

</template>

<script>
import AddSourceOrder from '@/components/dialogs/order/AddSourceOrder.vue'

export default {
  name: 'SourceOrder',
  components: { AddSourceOrder },
  props: ['parentSourceOrder'],
  data: () => ({
    openSourceOrderDialog: false,
  }),
  computed: {
    sourceOrder: {
      get () {
        return this.parentSourceOrder
      },
      set (newValue) {
        this.$emit('update:parentSourceOrder', newValue)
      }
    },
  },
  methods: {
    removeItem (form) {
      this.sourceOrder = this.sourceOrder.filter(f => f.id !== form.id)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>